export default __webpack_public_path__ + "static/media/Elephant.39f0e7d8.jpg";